(function() {
  'use strict';
  angular.module('claims')
    .controller('claimsSearchController', ['$scope', '$log','$state', '$stateParams','$translate','Claims', 'Members',
      '$q', '$filter', '$window', 'claimService', 'secSecurityService', 'taxIdBlockService','dsoProviderService','Dso','DsoUsers', '$transitions',
      function($scope, $log, $state, $stateParams,$translate,Claims, Members, $q, $filter, $window, claimService, secSecurityService, taxIdBlockService,dsoProviderService,Dso,DsoUsers,$transitions) {
          var vm = this;
          vm.benefitsMember = {};
          vm.criteria = {};
          vm.model = {};
          vm.selectedMember = false;
          vm.validate = validate;
          vm.loadMember = loadMember;
          vm.executeSearch = executeSearch;
          vm.searchClaimByDateRange = searchClaimByDateRange;
          vm.searchByCheckNumber = searchByCheckNumber;
          vm.searchByEFTNumber = searchByEFTNumber;
          vm.searchClaimByEFTNumber = searchClaimByEFTNumber;
          vm.running = false;
          vm.validating = false;
          vm.initMembers = initMembers;
          vm.changeMembers = changeMembers;
          vm.model.searchType = "claim";
          initMembers();
          initOptions();
          vm.minDate = '01/01/1900';
          vm.today   =  $filter('date')(new Date(),'MM/dd/yyyy');
          vm.claimsAccess = false;
          vm.isInternal = false;
          vm.approvedDsoTaxIds = [];
          vm.dsoTaxIds = [];
          vm.dsoTaxIdLocations = [];
          vm.taxIdListMax = 21;
          vm.showTaxIdSelect=true;
          vm.showGrid = true;
          $scope.oneAtATime = true;
          vm.dsoAdminUser = false;
          vm.selectedList = [];
          vm.claimsServiceUnavailable = false;
          $scope.status = {
              isMemberSearchOpen: true,
              isFirstDisabled: false
          };




          secSecurityService.hasAnyAuthority('DSO_ADMIN_USER').then((pUser) => {
              if(pUser){
                  vm.dsoAdminUser = true;
              }
          });

          secSecurityService.hasAnyAuthority('CLAIMS').then((val) => {
              vm.claimsAccess = val;
          });
          secSecurityService.getLoggedInUser().then((user) => {
              vm.isInternal = user.internal;
          });

          vm.search = function(criteria){
              vm.claimSearchResults = undefined;
              var x = vm.model.members;
              var selectedMember = {};
              var selectedPolicy;
              if(criteria === undefined) {
                  selectedMember = _.find(x, (m) => {
                      return _.find(m.policies, (p) => {
                              return p.referenceId == vm.model.referenceId;
                          }
                      );
                  });
                  vm.criteria = {
                      member: {
                          referenceId: vm.model.referenceId,
                          associatedMembers: vm.model.associatedMembers
                      },
                      type: vm.model.searchType,
                      subscriberId: vm.model.subscriberId
                  };
              }
              else {
                  vm.criteria = criteria;
                  selectedMember = vm.benefitsMember;
              }
              selectedPolicy = getPolicyByRefId(selectedMember, vm.criteria.member && vm.criteria.member.referenceId);
              if (hasDentalHmoPolicy(selectedPolicy)) {
                  vm.model.dhmoPolicyFound = true;
                  return;
              }
              //vm.running = true;
              var postObject = {
                  searchCriteria : vm.criteria,
                  member :selectedMember
              };
              executeSearch(postObject);
          };

          if (restoreModel()) {
            refreshSearch();
          }

          $scope.$watchGroup(['status.openDateRange','status.openEFT','status.openCheckNumber','status.isMemberSearchOpen'],function(val) {
              var watchList=[];
              if ($scope.status.openDateRange) {
                  watchList[0] = $scope.$watchGroup(['vm.model.taxId','vm.model.city','vm.model.state'], function(nVal,oVal) {
                      if (!_.isEqual(nVal,oVal)) {
                        vm.claimSearchResults = undefined;
                      }
                  });
                  watchList[1] = $scope.$watchCollection('vm.selectedList',function(nVal,oVal) {
                    if (!_.isEqual(nVal,oVal)) {
                      vm.claimSearchResults = undefined;
                    }
                  });
              }else{
                cancelWatch(watchList);
              }
          });
          vm.resetEnhancedSearchParameters = function resetEnhancedSearchParameters(){

              claimSearchReset();
              if($scope.status.isMemberSearchOpen){
                  resetCheckNumberSearchCriteria();
                  resetEftSearchCriteria();
                  resetDateRangeSearchCriteria();
              }else if($scope.status.openCheckNumber){
                  resetEftSearchCriteria();
                  resetDateRangeSearchCriteria();
                  resetMemberSearchCriteria();

              }else if($scope.status.openEFT){
                  resetCheckNumberSearchCriteria();
                  resetDateRangeSearchCriteria();
                  resetMemberSearchCriteria();

              }else if($scope.status.openDateRange){
                  resetCheckNumberSearchCriteria();
                  resetEftSearchCriteria();
                  resetMemberSearchCriteria();
              }
          };
          function resetMemberSearchCriteria(){
        	  if($scope.accordion.groups[0] && $scope.accordion.groups[0].$$childHead && $scope.accordion.groups[0].$$childHead.errorControl){
        		  $scope.accordion.groups[0].$$childHead.errorControl.hideErrors();
        	  }
              vm.model.subscriberId = "";
              vm.model.dateOfBirth = "";
              initMembers();
              initOptions();
          }
          function resetCheckNumberSearchCriteria(){
              vm.model.checkNumber = "";
          }
          function resetEftSearchCriteria(){
        	  if($scope.accordion.groups[2] && $scope.accordion.groups[2].$$childHead && $scope.accordion.groups[2].$$childHead.errorControl){
        		  $scope.accordion.groups[2].$$childHead.errorControl.hideErrors();
        	  }
              vm.model.eft = "";
          }
          function resetDateRangeSearchCriteria(){
        	  if($scope.accordion.groups[3] && $scope.accordion.groups[3].$$childHead && $scope.accordion.groups[3].$$childHead.errorControl){
        		  $scope.accordion.groups[3].$$childHead.errorControl.hideErrors();
        	  }
              vm.model.dateRangeFrom = "";
              vm.model.dateRangeTo = "";
              vm.model.taxId = "";
              vm.model.cities = [];
              vm.model.states = [];
          }

          vm.reset = function reset(){
        	  if($scope.accordion.groups[0] && $scope.accordion.groups[0].$$childHead && $scope.accordion.groups[0].$$childHead.errorControl){
        		  $scope.accordion.groups[0].$$childHead.errorControl.hideErrors();
        	  }
              vm.model={};
              initMembers();
              initOptions();
              claimSearchReset();
              $($window).scrollTop(0);
              $window.document.getElementById('subscriberId').focus();
          };
          vm.chkReset = function chkReset(){
              claimSearchReset();
              vm.model.checkNumber = "";
              $window.document.getElementById('checkNumber').focus();
          };
          vm.eftReset = function eftReset(){
        	  if($scope.accordion.groups[2] && $scope.accordion.groups[2].$$childHead && $scope.accordion.groups[2].$$childHead.errorControl){
        		  $scope.accordion.groups[2].$$childHead.errorControl.hideErrors();
        	  }
              claimSearchReset();
              vm.model.eft = "";
              $window.document.getElementById('eft').focus();
          };
          vm.dateRangeReset = function dateRangeReset(){
              document.getElementsByName('claimDateRangeSearchForm')[0].reset();
              if($scope.accordion.groups[3] && $scope.accordion.groups[3].$$childHead && $scope.accordion.groups[3].$$childHead.errorControl){
        		  $scope.accordion.groups[3].$$childHead.errorControl.hideErrors();
        	  }
              vm.model={};
              claimSearchReset();
              vm.selectedList=[];
              $window.document.getElementById('dateRangeFrom').focus();
          };
          function claimSearchReset(){
              vm.claimSearchResults = undefined;
              vm.running = false;
              vm.claimsServiceUnavailable = false;
              claimService.claimsSearchParams({});
              vm.model.searchType = "claim";
              $("#searchType").attr('checked', 'checked');
          }


          function initMembers(){
              vm.model.members = {};
              vm.model.referenceId = "";
              vm.validateDisabled = false;
              vm.memberNotFound = false;
              vm.model.dhmoPolicyFound = false;

          }

          function changeMembers(){
              vm.model.members = {};
              vm.model.referenceId = "";
              vm.validateDisabled = false;
              vm.memberNotFound = false;
              vm.model.claimBlockFound = false;
              vm.model.dhmoPolicyFound = false;
              vm.claimSearchResults = undefined;
          }

          function initOptions(){
              vm.optgroups = undefined;
              vm.options  = undefined;
          }

          function lookupParams(data) {
              let lookupParams = _.pick(vm.model,["subscriberId","dateOfBirth"]);
              lookupParams.subscriberId = $filter('subscriberId')(lookupParams.subscriberId);
              lookupParams.dateOfBirth = $filter('teledentDate')(lookupParams.dateOfBirth);
              return lookupParams;
          }

          function validate() {
              vm.claimSearchResults = undefined;
              $scope.accordion.groups[0].$$childHead.errorControl.showErrors();
              initMembers();
              initOptions();
              if ($scope.accordion.groups[0].$$childHead.claimsSearchForm.$valid) {
                  vm.validating = true;
                  vm.serviceUnavailable = false;
                  vm.model.noPolicy = false;
                  vm.model.dhmoPolicyFound = false;
                  Members.query(lookupParams(vm.model), (res) => {
                      let data = res.data;
                      vm.model.members = _.filter(data,(d) => {return d.subscriberId !== undefined;});
                      vm.model.members = taxIdBlockService.filterMembers(vm.model.members);
                      vm.model.members = claimService.checkPoliciesForClaimBlock(vm.model.members);
                      if(vm.model.members.length > 0 && vm.model.members[0].invalidMember) {
                          vm.subscriberIdBlock = true;
                          vm.subscriberIdBlockMessage = vm.model.members[0].supportString;
                          vm.running = false;
                          vm.validateDisabled = false;
                          vm.validating = false;
                      } else {
                          if (vm.model.members.length > 0) {
                              buildSelectOptions();
                              vm.model.referenceId = (vm.options || vm.optgroups || vm.model.members[0].policies.length === 0) ? "" : vm.model.members[0].policies[0].referenceId;
                              var policiesFound = false;
                              _.each(vm.model.members, (member, index) => {
                                  if(member.policies.length > 0) {
                                      policiesFound = true;
                                  }
                              });
                              if (!policiesFound || (vm.model.members.length === 1 && vm.model.members[0].policies.length === 0)) {
                                  if(vm.model.members[0].claimBlock) {
                                      vm.model.claimBlockFound = true;
                                      vm.validateDisabled = false;
                                  } else {
                                      vm.model.noPolicy = true;
                                  }
                              }
                          } else if (res.serviceUnavailable) {
                              vm.serviceUnavailable = true;
                          } else {
                              vm.memberNotFound = true;
                          }
                          vm.validating = false;
                          vm.validateDisabled = true;
                          vm.selectedMember = true;
                      }
                  },(error) => {
                      vm.validating= false;
                  });
              }

          }

          function loadMember() {
              initMembers();
              initOptions();
              vm.serviceUnavailable = false;
              claimService.associatedMembersPromise = Members.associatedMembers({referenceId: vm.referenceId}).$promise.then((res) => {return res.data;});
              claimService.getMemberByRefId(vm.referenceId).then(function (data) {
                  vm.model.subscriberId = data.subscriberId;
                  vm.model.dateOfBirth = data.dateOfBirth;
                  vm.model.referenceId = vm.referenceId;
                  build();
                  vm.model.dateOfBirth = $filter('portalDate')(vm.model.dateOfBirth);
                  vm.benefitsMember = data;

                  vm.model.referenceId = vm.referenceId;
                  vm.criteria = {"member":{"referenceId": vm.referenceId, "associatedMembers":false}, "subscriberId":vm.model.subscriberId, "type":vm.model.searchType};
                  vm.search(vm.criteria);
              });
          }

          function build()
          {
              Members.query(vm.model, (res) => {
                  let data = res.data;
                  vm.model.members = _.filter(data,(d) => {return d.subscriberId !== undefined;});
                  //vm.model.members = claimService.checkPoliciesForClaimBlock(vm.model.members);
                  if (vm.model.members.length > 0) {
                      buildSelectOptions();
                      var policiesFound = false;
                      _.each(vm.model.members, (member, index) => {
                          if(member.policies.length > 0) {
                              policiesFound = true;
                          }
                      });
                      if (!policiesFound  || (vm.model.members.length === 1 && vm.model.members[0].policies.length === 0)) {
                          vm.model.noPolicy = true;
                      }

                  } else if (res.serviceUnavailable) {
                      vm.serviceUnavailable = true;
                  } else {
                      vm.memberNotFound = true;
                  }
                  vm.validating = false;
                  vm.validateDisabled = true;
                  vm.selectedMember = true;
              });
          }

          function buildSelectOptions(){
              let memberNames = [];
              let groupNumbers = [];
              let multiMembersMultiPolicies = hasMultiMembersMultiPolicies();
              vm.optgroups = multiMembersMultiPolicies ? [] : undefined;
              _.each(vm.model.members,(member,index) => {
                  if (multiMembersMultiPolicies){
                      vm.optgroups[index] = {};
                      vm.optgroups[index].label =  member.firstName + ' ' + member.lastName;
                      vm.optgroups[index].options = [];
                      addOptions(vm.optgroups[index].options,member.policies);
                  }else{
                      addOptions(groupNumbers,member.policies);
                      addOptions(memberNames,member.policies,member.firstName + ' ' + member.lastName);
                  }
              });
              if (groupNumbers.length > 1 || memberNames.length > 1) {
                  vm.options = {};
                  vm.options.groups = groupNumbers && groupNumbers.length > 1 ? groupNumbers : undefined;
                  vm.options.members = memberNames && memberNames.length > 1 ? memberNames : undefined;
              }
          }

          function hasMultiMembersMultiPolicies(){
              let multiMembersMultiPolicies = false;
              if (vm.model.members.length > 1) {
                  let policies = [];
                  _.each(vm.model.members,(member) => {
                      if (member.policies.length > 1){
                          multiMembersMultiPolicies = true;
                      }else{
                          if(member.policies.length > 0) {
                              if (!_.find(policies,(p) => {return p===member.policies[0].groupNumber;})) {
                                  policies.push(member.policies[0].groupNumber);
                                  if (policies.length > 1) {multiMembersMultiPolicies = true;}
                              }
                          }
                      }
                  });
              }
              return multiMembersMultiPolicies;
          }


          $scope.$watch(() => vm.model.referenceId, function(refId) {
              vm.model.active = undefined;
              vm.model.secured = undefined;
              _.each(vm.model.members, (member) => {
                  let policy = _.find(member.policies, (p) => p.referenceId === refId );
                  if (policy) {
                      vm.model.active = policy.status === 'Active';
                      vm.model.cancelDate = policy.cancelDate;
                      vm.model.secured = policy.secured;
                      vm.model.dhmoPolicyFound = false;
                  }
              });
          });

          function searchByEFTNumber(criteria) {
            $scope.accordion.groups[2].$$childHead.errorControl.showErrors();
            if ($scope.accordion.groups[2].$$childHead.claimEftSearchForm.$valid) {
              searchClaimByEFTNumber(criteria);
            }
          }
          function searchClaimByEFTNumber(criteria) {
              vm.criteria = {
                  type: vm.model.searchType,
                  eft: vm.model.eft
              };
              executeSearch( {searchCriteria : vm.criteria});
          }

          function searchByCheckNumber(criteria){
            vm.criteria = {
                type: vm.model.searchType,
                checkNumber: vm.model.checkNumber
            };
            executeSearch( {searchCriteria : vm.criteria});
          }
          vm.searchByDateRange = function(criteria){
              $scope.accordion.groups[3].$$childHead.errorControl.showErrors();
              if(compareDates(vm.model.dateRangeFrom,vm.model.dateRangeTo)){
                  var toDate =  vm.model.dateRangeTo;
                  vm.model.dateRangeTo = vm.model.dateRangeFrom;
                  vm.model.dateRangeFrom = toDate;
              }
              if ($scope.accordion.groups[3].$$childHead.claimDateRangeSearchForm.$valid) {
                  searchClaimByDateRange();
              }
          };

          function searchClaimByDateRange(){
              vm.criteria = {
                  type: vm.model.searchType,
                  fromDate: $filter('teledentDate')(vm.model.dateRangeFrom),
                  toDate: $filter('teledentDate')(vm.model.dateRangeTo),
                  sTaxId: vm.model.taxId,
                  sState: vm.model.state,
                  sCity: vm.model.city,
                  locations: vm.selectedList
              };
              var postObject = {
                  searchCriteria : vm.criteria
              };
              vm.executeSearch(postObject);
          }

          function executeSearch(postObject) {
             vm.claimSearchResults = undefined;
             vm.running = true;
             claimService.initClaimSearchParams();
             vm.claimSearchResults = Claims.find(postObject).$promise;
             vm.running = false;
          }

          function compareDates(d1,d2){
              d1 = new Date(d1);
              d2 = new Date(d2);
              return d1 > d2;
          }

          function getPolicyByRefId(member, refId) {
              if (!(member && member.policies && refId)) {
                  return undefined;
              }
              return _.find(member.policies, (policy) => {
                  return policy.referenceId == refId;
              });
          }

          function hasDentalHmoPolicy(policy) {
              if (!policy) {
                  return false;
              }

              var policyType = ((policy.policyType || policy.type || '') + '').toLowerCase().replace(/\s+/g, '');
              return policyType === 'dentalhmo' || policyType === 'dhmo';
          }

          function addOptions(options, subscriberData, subscriberName){
              _.each(subscriberData,(data) => {
                  let optionName = subscriberName ? subscriberName : (data.secured ? "Policy in secured group" : data.groupNumber + " - " + data.policyType);
                  if (!_.find(options,(o) => {return o.name === optionName;})){
                      let option = {};
                      option.name  = optionName;
                      option.value = data.referenceId;
                      option.disabled = !!data.secured;
                      options.push(option);
                  }
              });
          }
         function restoreModel() {
            let modelRestored = false;
            let savedModel = claimService.claimsSearchParams();
            if (!_.isEmpty(savedModel)) {
                vm.model = angular.copy(savedModel.model);
                vm.selectedList = angular.copy(savedModel.locations);
                vm.referenceId = savedModel.referenceId;
                $scope.status = savedModel.status;
                vm.model.searchType = vm.model.searchType ? vm.model.searchType : "claim";
                modelRestored = true;
            }
            return modelRestored;
          }
          function refreshSearch() {
            switch (true) {
              case $scope.status.isMemberSearchOpen: vm.loadMember(); break;
              case $scope.status.openEFT: vm.searchClaimByEFTNumber(); break;
              case $scope.status.openCheckNumber: vm.searchByCheckNumber();break;
              case $scope.status.openDateRange: vm.searchClaimByDateRange(); break;
            }
          }
          function cancelWatch(watchList) {
            _.each(watchList,(unwatch) => {
              if (unwatch) {
                unwatch();
              }
            });
          }
          $transitions.onExit({ from:'claimsSearch', to: 'benefits.dashboard' }, function(transition) {
              claimService.claimsSearchParams({  model: angular.copy(vm.model),
                  referenceId: vm.model.referenceId,
                  status: $scope.status,
                  locations: angular.copy(vm.selectedList)
              });
          });
      }]);
})();
